// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters .categories {
  padding:0 2em;
}

.filters .categories a {
  display:inline-block;
  height:100%;
  cursor:pointer;
  padding:1em 2em;
  border-right:2px solid #ffffff55;
  text-decoration: none;
}

.filters .categories a:last-child {
  border-right:0;
}
.filters .categories a:hover {
  text-decoration:underline;
}


.titlebar .categories {
  padding:0 2em;
}
.titlebar .categories p {
  padding:1em 0;
}

.product {
  padding:1em 2em;
}
.sidebar {
  display:inline-block;
}
.sidebar .image {
  background:rgba(255,255,255,0.2);
  text-align:center;
  vertical-align:top;
  padding:2em 3em;
  margin-bottom:2em;
}

.sidebar .image img {
  width:auto;
  height:auto;
  max-height:40em;
}
.info {
  display:inline-block;
  width:99%;
  vertical-align:top;
}
.product:after {
  display:block;
  content:'';
  height:1px;
  clear:right;
}

h3 {color:white;}
h4 {font-size:1.6em;color:#111;}

tr:hover {
  background:rgba(0,0,0,0.04);
}

tr > *:nth-child(2), tr > *:nth-child(3), tr > *:nth-child(4) {
  width:20% !important;
  text-align:center;
}
.mat-table tr > *:nth-child(3), .mat-table tr > *:nth-child(4) {
  display:none;
}

table {
  width:100%;
  margin:1em 0 2em;
}
.certifications img {
  max-width:95%;
  display:inline-block;
  margin:0 1em 1em 0;
  vertical-align:top;
  float:left;
}
.documents {clear:both;}

@media only screen and (min-width:50em) {
  .info {
    width:69%;
    padding-right:5%;
    margin:0 0 2em 3em;
  }
  .sidebar {
    width:24%;
  }
  .mat-table tr > *:nth-child(3), .mat-table tr > *:nth-child(4) {
    display:table-cell;
  }

}

@media only screen and (min-width:80em) {
  .info {
    width:53em;
  }
  .sidebar {
    width:20em;
    padding:1em;
  }
  .sidebar ul {
    margin-left:1em;
  }

}

ul {
  list-style-type:circle;
}
.lit {
  color:#fff !important;
}

.dar {
  color:#000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/product/product.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA,IAAI,WAAW,CAAC;AAChB,IAAI,eAAe,CAAC,UAAU,CAAC;;AAE/B;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA,YAAY,UAAU,CAAC;;AAEvB;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".filters .categories {\n  padding:0 2em;\n}\n\n.filters .categories a {\n  display:inline-block;\n  height:100%;\n  cursor:pointer;\n  padding:1em 2em;\n  border-right:2px solid #ffffff55;\n  text-decoration: none;\n}\n\n.filters .categories a:last-child {\n  border-right:0;\n}\n.filters .categories a:hover {\n  text-decoration:underline;\n}\n\n\n.titlebar .categories {\n  padding:0 2em;\n}\n.titlebar .categories p {\n  padding:1em 0;\n}\n\n.product {\n  padding:1em 2em;\n}\n.sidebar {\n  display:inline-block;\n}\n.sidebar .image {\n  background:rgba(255,255,255,0.2);\n  text-align:center;\n  vertical-align:top;\n  padding:2em 3em;\n  margin-bottom:2em;\n}\n\n.sidebar .image img {\n  width:auto;\n  height:auto;\n  max-height:40em;\n}\n.info {\n  display:inline-block;\n  width:99%;\n  vertical-align:top;\n}\n.product:after {\n  display:block;\n  content:'';\n  height:1px;\n  clear:right;\n}\n\nh3 {color:white;}\nh4 {font-size:1.6em;color:#111;}\n\ntr:hover {\n  background:rgba(0,0,0,0.04);\n}\n\ntr > *:nth-child(2), tr > *:nth-child(3), tr > *:nth-child(4) {\n  width:20% !important;\n  text-align:center;\n}\n.mat-table tr > *:nth-child(3), .mat-table tr > *:nth-child(4) {\n  display:none;\n}\n\ntable {\n  width:100%;\n  margin:1em 0 2em;\n}\n.certifications img {\n  max-width:95%;\n  display:inline-block;\n  margin:0 1em 1em 0;\n  vertical-align:top;\n  float:left;\n}\n.documents {clear:both;}\n\n@media only screen and (min-width:50em) {\n  .info {\n    width:69%;\n    padding-right:5%;\n    margin:0 0 2em 3em;\n  }\n  .sidebar {\n    width:24%;\n  }\n  .mat-table tr > *:nth-child(3), .mat-table tr > *:nth-child(4) {\n    display:table-cell;\n  }\n\n}\n\n@media only screen and (min-width:80em) {\n  .info {\n    width:53em;\n  }\n  .sidebar {\n    width:20em;\n    padding:1em;\n  }\n  .sidebar ul {\n    margin-left:1em;\n  }\n\n}\n\nul {\n  list-style-type:circle;\n}\n.lit {\n  color:#fff !important;\n}\n\n.dar {\n  color:#000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
